import React from 'react';
import { Field } from 'redux-form';
import { Row, Col } from 'react-bootstrap';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';

/* renders the form content - inputs - textarea */
const customFormComponent = ({ input, label, type, className, cols, rows, meta: { touched, error, warning } }) => (
    <div className="input-wrapper">
      {/* this generates the form inputs */}
      { type !== 'textarea' &&
        <input {...input} placeholder={label} className={touched && error ? 'show-error '+ className : className} type={type}/>
      }
      {/* this generates the textarea */}
      { type === 'textarea' &&
        <textarea {...input} placeholder={label} className={touched && error ? 'show-error '+ className : className} type={type} cols={cols} rows={rows}/>
      }   
      {/* the error section   */} 
      {touched && ((error && <span className="form-error">{error}<i className="fa fa-exclamation-triangle" aria-hidden="true"></i></span>))}
    </div>
)

const FormData = ( props, translate, currentLanguage ) => {
        const formElementData = props.inputData; 
        var elements =  Object.keys(formElementData).map(function(keyName, keyIndex) {
            return (
              <Row className="form-group" key={keyIndex}>
                <Col md={12}>
                    <Field
                      name={ formElementData[keyName].name }
                      type={ formElementData[keyName].type }
                      label={ props.translate(formElementData[keyName].placeholder).props.children }
                      //label={ props.translate(formElementData[keyName].placeholder) }
                      className={ formElementData[keyName].className }
                      cols={ formElementData[keyName].component === 'textarea' ? formElementData[keyName].columns : ''}
                      rows={ formElementData[keyName].component === 'textarea' ? formElementData[keyName].rows : ''}
                      component={ customFormComponent }
                    />
                </Col>
              </Row>
            )
        }) 
      return (
        <span>
          {elements}
        </span>
      )
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(FormData);


// WEBPACK FOOTER //
// ./src/components/form/form-data.jsx